// extracted by mini-css-extract-plugin
module.exports = {"container":"Quote_container__suMmw","quote":"Quote_quote__ovJHB","offsetLeft":"Quote_offsetLeft__vMMWk","offsetRight":"Quote_offsetRight___dIUw"};